import { fieldLabelString } from 'components/core/dynamic-form/fields/FieldLabel'
import { RenderFieldProps, UnknownField } from 'components/core/dynamic-form/fields/RenderField'
import { C1FileInput } from 'components/core/RHKFormComponents/C1FileInput'
import { FC } from 'react'
import { useIntl } from 'react-intl'

export const RenderFileField: FC<RenderFieldProps> = ({ field, cField, errors, disabled }) => {
    const intl = useIntl()

    if (field.type.oneofKind !== 'fileField') return <UnknownField field={field} />

    const fileField = field.type.fileField

    return (
        <C1FileInput
            label={fieldLabelString(field.displayName, field.required, intl)}
            name={field.name}
            value={cField.value}
            onChange={cField.onChange}
            onBlur={cField.onBlur}
            error={!!errors[field.name]}
            helperText={(errors[field.name]?.message as string) || field.description}
            disabled={disabled}
            acceptedFileTypes={fileField.acceptedFileTypes}
        />
    )
}
